/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getFeedGenerator.defs.js'
export * as $defs from './getFeedGenerator.defs.js'
